import { GHLLanguageKeys as e } from "./ghl-ui.es285.js";
import o from "./ghl-ui.es723.js";
const m = {
  name: e.englishUS,
  locale: o
};
export {
  m as date_en_US
};
